/*
 * @Description:
 * @Autor: wk
 * @Date: 2019-06-11 11:16:08
 * @LastEditors: lkz
 * @LastEditTime: 2021-11-07 09:34:11
 */
import * as httpAgent from 'utils/http'
import { addRequestParam, returnReqURI } from '../utils'

/** 工单原因 */
export function serviceIssueList(params, options) {
  return httpAgent.GET(returnReqURI('woTemplate/serviceIssueList.json'), params, options)
}
export function getLevelCount3Issues(params, options) {
  return httpAgent.GET(returnReqURI('woTemplate/getLevelCount3Issues.json'), params, options)
}


/** 创建工单 */
export function createWorkOrder(params, options = { type: 'formData', errorMsg: 'none', context: true }) {
  params = addRequestParam(params)
  return httpAgent.POST(returnReqURI('workorder/extend/createWorkOrder'), params, options)
}
/** 获取全部工单 */
// export function queryAllWorkOrder(params, options) {
//   return httpAgent.GET('workorder/extend/queryAllWorkOrder.json', params, options)
// }
/** 分配任务 */
export function dispatchWorkOrderManual(params, options = { type: 'formData' }) {
  params = addRequestParam(params)
  return httpAgent.POST(returnReqURI('workorder/extend/dispatchWorkOrderManual.json'), params, options)
}
/** 转交任务 */
export function transTask(params, options = { type: 'formData' }) {
  params = addRequestParam(params)
  return httpAgent.POST(returnReqURI('workorder/extend/transTask.json'), params, options)
}
/** 认领任务 */
export function claimCurrentTask(params, options = { type: 'formData' }) {
  params = addRequestParam(params)
  return httpAgent.POST(returnReqURI('workorder/extend/claimCurrentTask.json'), params, options)
}
/** 催促任务 */
export function workOrderTaskUrge(params, options = { type: 'formData' }) {
  params = addRequestParam(params)
  return httpAgent.POST(returnReqURI('workorder/extend/workOrderTaskUrge.json'), params, options)
}
/** 获取模板配置 */
export function queryTempleteInfo(params, options) {
  return httpAgent.POST(
    returnReqURI(`woTemplate/${options && options.isNewApi ? 'selectTemplateByParam' : 'selectTemplateByCondition'}`),
    params,
    options
  )
}
/** 查询工单详情 */
export function getWorkOrderDetail(params, options) {
  params = addRequestParam(params)
  return httpAgent.GET(returnReqURI('workorder/extend/getWorkOrderDetail.json'), params, options)
}
/** 回复工单 */
export function interveneTask(params, options = { type: 'formData' }) {
  params = addRequestParam(params)
  return httpAgent.POST(returnReqURI('workorder/extend/interveneTask.json'), params, options)
}
/** 取消工单 */
export function cancelWorkOrder(params, options = { type: 'formData' }) {
  params = addRequestParam(params)
  return httpAgent.POST(returnReqURI('workorder/extend/cancelWorkOrder.json'), params, options)
}
/** 备注工单 */
export function addRemark(params, options = { type: 'formData' }) {
  params = addRequestParam(params)
  return httpAgent.POST(returnReqURI('workorder/extend/addRemark.json'), params, options)
}
/** 获取任务节点可操作列表 */
export function getTaskOperateType(params, options) {
  params = addRequestParam(params)
  return httpAgent.GET(returnReqURI('workorder/extend/getTaskOperateType.json'), params, options)
}
/** 获取用户标签 */
export function findLabelByUserInfo(params, options) {
  return httpAgent.GET(returnReqURI('labelService/findLabelByUserInfo.json'), params, options)
}
/** 给用户打标签 */
export function saveLabel(params, options) {
  return httpAgent.GET(returnReqURI('labelService/saveLabel.json'), params, options)
}
/** 客服信息列表 */
export function searchCustomerServiceList(params, options) {
  params = addRequestParam(params)
  return httpAgent.GET(returnReqURI('workorder/extend/searchCustomerServiceList.json'), params, options)
}
/** 技能组信息列表 */
export function getSkillGroupListByTitle(params, options) {
  return httpAgent.GET(returnReqURI('workorder/extend/getSkillGroupListByTitle.json'), params, options)
}
/** 搜索客服名称 */
export function findAllServiceByRealName(params, options) {
  // return httpAgent.GET(returnReqURI('customerService/searchServiceByRealName.json'), params, options)
  return httpAgent.GET(returnReqURI('workorder/searchByRealName.json'), params, options)
}
/** 处理工单 */
export function handleTask(params, options) {
  params = addRequestParam(params)
  return httpAgent.GET(returnReqURI('workorder/extend/handleTask.json'), params, options)
}

/** ----------------------工单2.2涉及接口-------------------- */

/** 工单列表页查询视图列表 */
export function workViewList(params, options) {
  return httpAgent.GET(returnReqURI('workView/workViewList'), params, options)
}
/** 查询全部工单 */
export function queryAllWorkOrderList(params, options) {
  params = addRequestParam(params)
  return httpAgent.POST(returnReqURI('workorder/extend/queryAllWorkOrderList'), params, options)
}
/** 查询业务域下线索配置 */
export function queryCluesTypeByRegionId(params, options) {
  return httpAgent.GET(returnReqURI('workRegion/queryCluesTypeByRegionId'), params, options)
}
/** 单号查商品列表 */
export function queryOrderProducts(params, options) {
  params = addRequestParam(params)
  return httpAgent.GET(returnReqURI('workorder/extend/queryOrderProducts'), params, options)
}
/** 查询用户对应角色类型 */
export function selectByConditions(params, options) {
  return httpAgent.GET(returnReqURI('customerRole/selectByConditions'), params, options)
}
// 查询业务域下角色列表
export function queryRoleByRegionId(params, options) {
  return httpAgent.GET(returnReqURI('workRegion/queryRoleByRegionId'), params, options)
}
// 任务操作评价
export function appraiseLog(params, options) {
  return httpAgent.GET(returnReqURI('workorder/extend/appraiseLog'), params, options)
}
// 查询任务详情页面跳转类型
export function queryOrderDetailType(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/workorder/queryOrderDetailType.json', params, options)
}
/** 查询用户对应角色类型 */
export function specialQuery(params, options) {
  return httpAgent.POST(returnReqURI('customerRole/selectByConditions'), params, options)
}
/** 查询客服 */
export function allocationEmpId(params, options) {
  return httpAgent.GET(returnReqURI('customerService/searchServiceByRealName'), params, options)
}
/** 查询技能组 */
export function allocationSkillGroupId(params, options) {
  return httpAgent.GET(returnReqURI('skillGroup/findAllGroup'), params, options)
}
/** 查询任务类型 */
export function selectChildList(params, options) {
  return httpAgent.GET(returnReqURI('tasktype/selectChildList'), params, options)
}
/** 查询队列 */
export function findQueueId(params, options) {
  return httpAgent.GET(returnReqURI('queue/queryAllByParam'), params, options)
}
/** 查询队列 */
export function getStoreInfoByOutSoId(params, options) {
  // params = addRequestParam(params)
  return httpAgent.GET(returnReqURI('workorder/getStoreInfoByOutSoId'), params, options)
}
// 任务日志（全部）
export function getOperateLogs(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/wooperatelog/getOperateLogs.json', params, options)
}
/** 查询物流下拉枚举 */
export function listByInvoiceNum(params, options) {
  // params = addRequestParam(params)
  return httpAgent.GET(returnReqURI('logistics/listByInvoiceNum'), params, options)
}
// 获取结案类型
export function getCloseListByTaskType(params, options) {
  return httpAgent.POST('/yunjixinyunadmin/admin/xinyun/closetype/getCloseListByTaskType.json', params, options)
}

/** 查询用户对应角色类型 */
export function selectWareByConditions(params, options) {
  return httpAgent.GET(returnReqURI('customerRole/getCustomerRoleList'), params, options)
}

/** 清空未读 */
export function clearNoReadCnt(params, options) {
  return httpAgent.GET(returnReqURI('workorder/extend/clearNoReadCnt'), params, options)
}

/** 工单类型 */
export function selectByWoType(params, options) {
  return httpAgent.GET(returnReqURI('workView/selectByWoType'), params, options)
}

/** 物流仓储获取排序 */
export function queryShowSortInfo(params, options) {
  return httpAgent.GET(returnReqURI('workView/queryShowSortInfo'), params, options)
}

/** 物流仓储保存排序 */
export function sortInfo(params, options) {
  return httpAgent.POST(returnReqURI('workView/updateShowSortInfo.json'), params, options)
}

/** 物流保存判责方 */
export function assignResponsibilityPart(params, options) {
  return httpAgent.POST(returnReqURI('workorder/extend/assignResponsibilityPart.json'), params, options)
}

/** 获取标签 */
export function getWorkOrderLabelOptions(params, options) {
  return httpAgent.GET(returnReqURI('workView/getWorkOrderLabelList'), params, options)
}
